import { ReactComponent as GraphArrowIncrease } from "assets/svg/graph-arrow-increase.svg";
import { ReactComponent as GraphArrowDecrease } from "assets/svg/graph-arrow-decrease.svg";

import { NullableNumber, ReportItemType } from "../../types/Reports";
import { formatValueAndUnitBasedOnTypeInReport } from "./utils/reportFormat";
import { getAverageSubject } from "./utils/reportString";

type ReportAverageTextProps = {
    itemType: ReportItemType;
    average: NullableNumber;
    prevAverage: NullableNumber;
    unit: string;
    selectedMonth: string;
};

export default function ReportAverageText({
    itemType,
    average,
    prevAverage,
    unit,
    selectedMonth,
}: Readonly<ReportAverageTextProps>) {
    const averageDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, average, unit, true);

    const usedText = getAverageSubject(itemType);

    let icon = <></>;

    if (average !== null && prevAverage !== null) {
        if (average > prevAverage) {
            icon = <GraphArrowIncrease width="16px" height="16px" />;
        } else if (average < prevAverage) {
            icon = <GraphArrowDecrease width="16px" height="16px" />;
        }
    }

    return <section className="report-average-text mt-2">
        {icon}
        <p>
            {'On average, '}
            <span className="report-average-text-hl">{averageDisplay}</span>
            {' '}
            <span>{`of ${usedText} per day in ${selectedMonth}.*`}</span>
        </p>
    </section>;
}
